import { RootState } from 'app/store';

export const selectSearchResults = (state: RootState) =>
  state.search.searchResults;

export const selectSearchLoading = (state: RootState) => state.search.loading;

export const selectSearchError = (state: RootState) => state.search.error;

export const selectResultsTotalCount = (state: RootState) => {
  const contractsLength =
    state.search.searchResults?.contractsResults?.length ?? 0;
  const billsLength = state.search.searchResults?.billsResults?.length ?? 0;
  const offersLength = state.search.searchResults?.offersResults?.length ?? 0;

  return contractsLength + offersLength + billsLength;
};
